import * as draftListActionTypes from "./actionTypes";

export function updateDeletePopup(data) {
    return {
        type: draftListActionTypes.UPDATE_DELETE_POPUP,
        ...data,
    };
}

export function fetchDraftWarrentyListsuccess(data) {
    return {
        type: draftListActionTypes.FETCH_DRAFT_WARRANTY_LIST_SUCCESS,
        ...data,
    };
}

export function fetchDraftWarrentyList(data) {
    return {
        type: draftListActionTypes.FETCH_DRAFT_WARRANTY_LIST,
        ...data,
    };
}


export function deleteDraftWarrentyItemSuccess(data) {
    return {
        type: draftListActionTypes.DELETE_DRAFT_WARRANTY_ITEM_SUCCESS,
        ...data,
    };
}

export function deleteDraftWarrentyItem(data) {
    return {
        type: draftListActionTypes.DELETE_DRAFT_WARRANTY_ITEM,
        ...data,
    };
}

export const addClickElements = (id: string): any => {
    return {
        type: draftListActionTypes.ADD_DASHBOARD_CLICK_ELEMENTS,
        id,
    };
};
